import {USER_RESPORT_ACTIIVITIES_RESOURCE} from '../api/resources';
import {addResource, deleteResource, fetchResource, updateResource} from './remote';

export const fetchUserReports = fetchResource(USER_RESPORT_ACTIIVITIES_RESOURCE);
export const addUserReport = addResource(USER_RESPORT_ACTIIVITIES_RESOURCE);
export const updateUserReport = updateResource(USER_RESPORT_ACTIIVITIES_RESOURCE);
export const deleteUserReport = deleteResource(USER_RESPORT_ACTIIVITIES_RESOURCE);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/user_reports.js